import { useTranslation } from 'react-i18next'
import { Box, Typography, Button, Stack } from '@mui/material'
import { AttachFile, Visibility } from '@mui/icons-material'

export default function FilePreview({
    file
}) {

    const { t } = useTranslation()

    // More robust base64 image detection
    // More robust base64 image detection
    const isImage = (typeof file === 'string') && (
        file.startsWith('data:image/') ||
        file.includes('data:image') ||
        /\.(jpg|jpeg|png|gif|bmp|webp|svg)$/i.test(file)
    )

    const isPdf = (typeof file === 'string') && (
        file.startsWith('data:application/pdf') ||
        file.includes('data:application/pdf') ||
        /\.pdf$/i.test(file)
    )

    return (

        <Box mt={2}>
            {isImage && (
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        overflow: 'hidden'
                    }}
                >
                    <img
                        src={file}
                        alt="Transaction file"
                        style={{
                            maxHeight: '100%',
                            maxWidth: '100%',
                            objectFit: 'contain'
                        }}
                        onError={(e) => {
                            console.error('Image failed to load:', e)
                            console.log('Image src:', file)
                        }}
                        onLoad={() => {
                            console.log('Image loaded successfully')
                        }}
                    />
                </Box>
            )}
            {isPdf && (
                <Box
                    sx={{
                        width: '100%',
                        height: 600,
                        border: 1,
                        borderColor: 'divider',
                        display: 'flex',
                        flexDirection: 'column',
                        bgcolor: 'grey.50'
                    }}
                >
                    <Box sx={{ p: 1, borderBottom: 1, borderColor: 'divider', bgcolor: 'background.paper' }}>
                        <Stack direction="row" alignItems="center" spacing={1} justifyContent="space-between">
                            <Stack direction="row" alignItems="center" spacing={1}>
                                <AttachFile sx={{ fontSize: 20, color: 'text.secondary' }} />
                                <Typography variant="body2" color="textSecondary">
                                    {t("PDF Document")}
                                </Typography>
                            </Stack>
                            <Button
                                size="small"
                                startIcon={<Visibility />}
                                onClick={() => {
                                    // Create a blob from base64 and open in new tab
                                    const isPdfBase64 = (typeof file === 'string') && (
                                        file.startsWith('data:application/pdf') ||
                                        file.includes('data:application/pdf')
                                    )
                                    if(!isPdfBase64) {
                                        window.open(file, '_blank');
                                        return;
                                    }
                                    const base64Data = file.split(',')[1];
                                    const byteArray = Uint8Array.from(atob(base64Data), c => c.charCodeAt(0));
                                    const blob = new Blob([byteArray], { type: 'application/pdf' });
                                    const url = URL.createObjectURL(blob);
                                    window.open(url, '_blank');
                                    // Clean up the URL after a delay
                                    setTimeout(() => URL.revokeObjectURL(url), 1000);
                                }}
                            >
                                {t('Open in New Tab')}
                            </Button>
                        </Stack>
                    </Box>
                    <Box sx={{ flex: 1, overflow: 'hidden' }}>
                        <iframe
                            src={file}
                            style={{
                                width: '100%',
                                height: '100%',
                                border: 'none'
                            }}
                            title="PDF Preview"
                        />
                    </Box>
                </Box>
            )}
        </Box>
    )
}
